// extracted by mini-css-extract-plugin
export default {"wrapper":"calling_wrapper__5rnvD"};